import { put, takeLatest, takeEvery, select } from 'redux-saga/effects';
import helpers from 'utils/helpers';
import { get } from 'lodash';
const { rp } = helpers;

const GET_PAYMENT_METHODS_REQUEST = 'GET_PAYMENT_METHODS_REQUEST';
const GET_PAYMENT_METHODS_SUCCESS = 'GET_PAYMENT_METHODS_SUCCESS';
const GET_PAYMENT_METHODS_FAILURE = 'GET_PAYMENT_METHODS_FAILURE';

const GET_PAYMENT_METHOD_REQUEST = 'GET_PAYMENT_METHOD_REQUEST';
const GET_PAYMENT_METHOD_SUCCESS = 'GET_PAYMENT_METHOD_SUCCESS';
const GET_PAYMENT_METHOD_FAILURE = 'GET_PAYMENT_METHOD_FAILURE';

const ADD_PAYMENT_METHOD_REQUEST = 'ADD_PAYMENT_METHOD_REQUEST';
const ADD_PAYMENT_METHOD_SUCCESS = 'ADD_PAYMENT_METHOD_SUCCESS';
const ADD_PAYMENT_METHOD_FAILURE = 'ADD_PAYMENT_METHOD_FAILURE';

const ADD_ADDRESS_REQUEST = 'ADD_ADDRESS_REQUEST';
const ADD_ADDRESS_SUCCESS = 'ADD_ADDRESS_SUCCESS';
const ADD_ADDRESS_FAILURE = 'ADD_ADDRESS_FAILURE';

const UPDATE_ADDRESS_TYPE_REQUEST = 'UPDATE_ADDRESS_TYPE_REQUEST';
const UPDATE_ADDRESS_TYPE_SUCCESS = 'UPDATE_ADDRESS_TYPE_SUCCESS';
const UPDATE_ADDRESS_TYPE_FAILURE = 'UPDATE_ADDRESS_TYPE_FAILURE';

const GET_ADDRESSES_REQUEST = 'GET_ADDRESSES_REQUEST';
const GET_ADDRESSES_SUCCESS = 'GET_ADDRESSES_SUCCESS';
const GET_ADDRESSES_FAILURE = 'GET_ADDRESSES_FAILURE';

const GET_TRANSACTIONS_REQUEST = 'GET_TRANSACTIONS_REQUEST';
const GET_TRANSACTIONS_SUCCESS = 'GET_TRANSACTIONS_SUCCESS';
const GET_TRANSACTIONS_FAILURE = 'GET_TRANSACTIONS_FAILURE';

const GET_RESCHEDULE_PICKUP_REQUEST = 'GET_RESCHEDULE_PICKUP_REQUEST';
const GET_RESCHEDULE_PICKUP_SUCCESS = 'GET_RESCHEDULE_PICKUP_SUCCESS';
const GET_RESCHEDULE_PICKUP_FAILURE = 'GET_RESCHEDULE_PICKUP_FAILURE';

const ADD_RESCHEDULE_PICKUP_REQUEST = 'ADD_RESCHEDULE_PICKUP_REQUEST';
const ADD_RESCHEDULE_PICKUP_SUCCESS = 'ADD_RESCHEDULE_PICKUP_SUCCESS';
const ADD_RESCHEDULE_PICKUP_FAILURE = 'ADD_RESCHEDULE_PICKUP_FAILURE';

const GET_INFO_REQUEST = 'GET_INFO_REQUEST';
const GET_INFO_SUCCESS = 'GET_INFO_SUCCESS';
const GET_INFO_FAILURE = 'GET_INFO_FAILURE';

const GET_COUPONS_REQUEST = 'GET_COUPONS_REQUEST';
const GET_COUPONS_SUCCESS = 'GET_COUPONS_SUCCESS';
const GET_COUPONS_FAILURE = 'GET_COUPONS_FAILURE';

const ADD_COUPON_REQUEST = 'ADD_COUPON_REQUEST';
const ADD_COUPON_SUCCESS = 'ADD_COUPON_SUCCESS';
const ADD_COUPON_FAILURE = 'ADD_COUPON_FAILURE';

export const getPaymentMethodsRequest = params => ({
  type: GET_PAYMENT_METHODS_REQUEST,
  ...params
});

export const getPaymentMethodRequest = params => ({
  type: GET_PAYMENT_METHOD_REQUEST,
  ...params
});

export const addPaymentMethodRequest = params => ({
  type: ADD_PAYMENT_METHOD_REQUEST,
  ...params
});

export const addAddressRequest = params => ({
  type: ADD_ADDRESS_REQUEST,
  ...params
});

export const updateAddressTypeRequest = params => ({
  type: UPDATE_ADDRESS_TYPE_REQUEST,
  ...params
});

export const getAddressesRequest = params => ({
  type: GET_ADDRESSES_REQUEST,
  ...params
});

export const getTransactionsRequest = params => ({
  type: GET_TRANSACTIONS_REQUEST,
  ...params
});

export const getReschedulePickupRequest = params => ({
  type: GET_RESCHEDULE_PICKUP_REQUEST,
  ...params
});

export const addReschedulePickupRequest = params => ({
  type: ADD_RESCHEDULE_PICKUP_REQUEST,
  ...params
});

export const getInfoRequest = params => ({
  type: GET_INFO_REQUEST,
  ...params
});

export const getCouponsRequest = params => ({
  type: GET_COUPONS_REQUEST,
  ...params
});

export const addCouponRequest = params => ({
  type: ADD_COUPON_REQUEST,
  ...params
});

function* getPaymentMethods(action) {
  const options = {
    method: 'GET',
    uri: `${process.env.REACT_APP_BASE_URL}/customer/methods`,
    json: true
  };

  try {
    const data = yield rp(options);

    if (data.success && data.data) {
      yield put({
        type: GET_PAYMENT_METHODS_SUCCESS,
        paymentMethods: data.data.resources
      });
    } else {
      yield put({ type: GET_PAYMENT_METHODS_FAILURE });
    }
  } catch (e) {
    console.error(e);
    yield put({ type: GET_PAYMENT_METHODS_FAILURE });
  }
}

function* getPaymentMethod(action) {
  const { paymentType } = action;

  if (!paymentType) console.error('missing payment type');

  const options = {
    method: 'GET',
    uri: `${process.env.REACT_APP_BASE_URL}/customer/method/${paymentType}`,
    json: true
  };

  try {
    const data = yield rp(options);

    if (data.success && data.data) {
      let paymentMethodDetail = false;

      switch (paymentType) {
        case 'stripe':
          paymentMethodDetail = data.data.last4 ? data.data : false;
          break;
        case 'alipayGlobalWeb':
          break;
      }

      yield put({
        type: GET_PAYMENT_METHOD_SUCCESS,
        paymentMethodDetail
      });
    } else {
      yield put({ type: GET_PAYMENT_METHOD_FAILURE });
    }
  } catch (e) {
    console.error(e);
    yield put({ type: GET_PAYMENT_METHOD_FAILURE });
  }
}

function* addPaymentMethod(action) {
  if (action.preRequestError) {
    yield put({ type: ADD_PAYMENT_METHOD_FAILURE });
  } else if (!action.preRequest) {
    const { token, name, paymentType } = action;

    if (!paymentType) console.error('missing payment type');

    let body;

    switch (paymentType) {
      case 'stripe':
        body = {
          token,
          name
        };
        break;
      case 'alipayGlobalWeb':
        break;
    }

    const options = {
      method: 'POST',
      uri: `${process.env.REACT_APP_BASE_URL}/customer/method/${paymentType}`,
      body,
      json: true
    };

    try {
      const data = yield rp(options);

      if (data.success) {
        let paymentData;

        switch (paymentType) {
          case 'stripe':
            paymentData = {
              cardNumber: get(data, 'data.0.last4'),
              cardBrand: get(data, 'data.0.brand')
            };
            break;
          case 'alipayGlobalWeb':
            break;
        }

        window.dataLayer.push({
          event: 'Bind Credit Card Success',
          paymentData
        });

        helpers.message.success(
          window.t('error_code.payment-success'),
          'account'
        );

        yield put({
          type: ADD_PAYMENT_METHOD_SUCCESS
        });
      } else {
        let errorMessage;
        switch (data.code) {
          case '1005':
          case '3002':
          case '3005':
          case '3006':
          case '1113':
            errorMessage = window.t(`error_code.payment-${data.code}`);
            break;
          default:
            errorMessage = window.t('error_code.payment-fail');
        }

        helpers.message.error(errorMessage, 'account');

        window.dataLayer.push({
          event: 'Bind Credit Card Error',
          errorData: {
            backendMessage: data.message,
            frontendMessage: errorMessage,
            code: data.code
          }
        });

        yield put({ type: ADD_PAYMENT_METHOD_FAILURE });
      }
    } catch (e) {
      console.error(e);
      yield put({ type: ADD_PAYMENT_METHOD_FAILURE });
    }
  }
}

function* addAddress(action) {
  const { address } = action;

  const options = {
    method: 'POST',
    uri: `${process.env.REACT_APP_BASE_URL}/addresses`,
    body: address,
    json: true
  };

  try {
    const response = yield rp(options);

    if (response.success) {
      yield put({
        type: ADD_ADDRESS_SUCCESS,
        addresses: [response.data]
      });
    } else {
      yield put({ type: ADD_ADDRESS_FAILURE });
    }
  } catch (e) {
    console.error(e);
    yield put({ type: ADD_ADDRESS_FAILURE });
  }
}

function* updateAddressType(action) {
  const { ref, addressType } = action;

  const options = {
    method: 'POST',
    uri: `${process.env.REACT_APP_BASE_URL}/customer/addresses/${ref}/type`,
    body: { type: addressType },
    json: true
  };

  try {
    const response = yield rp(options);

    if (response.success) {
      yield put({
        type: UPDATE_ADDRESS_TYPE_SUCCESS
      });
    } else {
      yield put({ type: UPDATE_ADDRESS_TYPE_FAILURE });
    }
  } catch (e) {
    console.error(e);
    yield put({ type: UPDATE_ADDRESS_TYPE_FAILURE });
  }
}

function* getAddresses(action) {
  const { origin, destination } = action;

  const originOptions = {
    method: 'GET',
    uri: `${process.env.REACT_APP_BASE_URL}/customer/addresses/${origin}/`,
    json: true
  };
  const destinationOptions = {
    method: 'GET',
    uri: `${process.env.REACT_APP_BASE_URL}/customer/addresses/${destination}/`,
    json: true
  };

  try {
    const originData = yield rp(originOptions);
    const destinationData =
      origin !== destination
        ? yield rp(destinationOptions)
        : { success: true, data: { resources: [] } };

    let addresses;

    if (originData.success && destinationData.success) {
      const originAddresses = originData.data.resources;
      const destinationAddresses = destinationData.data.resources;
      addresses = originAddresses.concat(destinationAddresses);

      yield put({
        type: GET_ADDRESSES_SUCCESS,
        addresses
      });
    } else {
      yield put({ type: GET_ADDRESSES_FAILURE });
    }
  } catch (e) {
    console.error(e);
    yield put({ type: GET_ADDRESSES_FAILURE });
  }
}

function* getTransactions(action) {
  const transactions = yield select(s => get(s, 'users.transactions') || {});
  const { currentPage } = transactions;
  const page = action.page || 1;

  if (!currentPage || currentPage < page || page === 1) {
    const options = {
      method: 'GET',
      uri: `${process.env.REACT_APP_BASE_URL}/customer/transactions?page=${page}`,
      json: true
    };

    try {
      const data = yield rp(options);

      if (data.success && data.data.resources) {
        const { resources, meta } = data.data;
        let stackData = transactions.data || [];
        stackData = page === 1 ? resources : stackData.concat(resources);
        yield put({
          type: GET_TRANSACTIONS_SUCCESS,
          transactions: {
            data: stackData,
            currentPage: meta.currentPage,
            lastPage: meta.lastPage
          }
        });
      } else {
        yield put({ type: GET_TRANSACTIONS_FAILURE });
      }
    } catch (e) {
      console.error(e);
      yield put({ type: GET_TRANSACTIONS_FAILURE });
    }
  } else {
    yield put({
      type: GET_TRANSACTIONS_SUCCESS,
      transactions
    });
  }
}

function* getReschedulePickup(action) {
  const { ref } = action;

  const availableOptions = {
    method: 'GET',
    uri: `${process.env.REACT_APP_BASE_URL}/orders/${ref}/can-reschedule`,
    json: true
  };

  const timeDateOptions = {
    method: 'GET',
    uri: `${process.env.REACT_APP_BASE_URL}/orders/${ref}/available-pickup-time`,
    json: true
  };

  try {
    const data = yield rp(availableOptions);
    const timeDate = yield rp(timeDateOptions);

    if (data.success && timeDate.success) {
      yield put({
        type: GET_RESCHEDULE_PICKUP_SUCCESS,
        canReschedule: true,
        timeDate: timeDate.data
      });
    } else if (!data.success && timeDate.success) {
      yield put({
        type: GET_RESCHEDULE_PICKUP_SUCCESS,
        canReschedule: false,
        timeDate: timeDate.data
      });
    } else {
      yield put({ type: GET_RESCHEDULE_PICKUP_FAILURE });
    }
  } catch (e) {
    console.error(e);
    helpers.message.error(window.t('common.err_msg.error'), 'auth');
    yield put({
      type: GET_RESCHEDULE_PICKUP_FAILURE
    });
  }
}

function* addReschedulePickup(action) {
  const { ref, date, time } = action;

  const gtmFail = () => {
    window.dataLayer.push({
      event: 'Pick Up Reschedule Fail'
    });
  };

  const options = {
    method: 'POST',
    uri: `${process.env.REACT_APP_BASE_URL}/orders/${ref}/reschedule`,
    body: {
      date,
      time
    },
    json: true
  };

  try {
    const result = yield rp(options);
    if (result.success === true) {
      window.dataLayer.push({
        event: 'Submit Pick Up Reschedule'
      });

      yield put({
        type: ADD_RESCHEDULE_PICKUP_SUCCESS
      });
    } else {
      gtmFail();

      window.t(`error_code.${result.code}`) !== `error_code.${result.code}`
        ? helpers.message.error(window.t(`error_code.${result.code}`), 'auth')
        : helpers.message.error(window.t('common.err_msg.error'), 'auth');

      yield put({
        type: ADD_RESCHEDULE_PICKUP_FAILURE,
        message: result.message
      });
    }
  } catch (e) {
    gtmFail();
    console.error(e);
    helpers.message.error(window.t('common.err_msg.error'), 'auth');
    yield put({ type: ADD_RESCHEDULE_PICKUP_FAILURE });
  }
}

function* getInfo(action) {
  const options = {
    method: 'GET',
    uri: `${process.env.REACT_APP_BASE_URL}/customer/info`,
    json: true
  };

  try {
    const data = yield rp(options);

    if (data.success && data.data) {
      yield put({
        type: GET_INFO_SUCCESS,
        info: data.data
      });
    } else {
      yield put({ type: GET_INFO_FAILURE });
    }
  } catch (e) {
    console.error(e);
    yield put({ type: GET_INFO_FAILURE });
  }
}

function* getCoupons(action) {
  const { routeData } = action;

  const options = {
    method: 'GET',
    uri: `${process.env.REACT_APP_BASE_URL}/customer/coupons`,
    json: true
  };

  if (routeData) {
    options.method = 'POST';
    options.uri = `${process.env.REACT_APP_BASE_URL}/transaction/available-coupons`;
    options.form = {
      fromCountry: routeData.origin,
      toCountry: routeData.destination,
      totalRate: routeData.totalRate,
      service: routeData.service,
      shipmentRef: routeData.shipmentRef
    };
  }

  try {
    const data = yield rp(options);

    if (data.success && data.data.resources) {
      yield put({
        type: GET_COUPONS_SUCCESS,
        coupons: data.data.resources
      });
    } else {
      yield put({ type: GET_COUPONS_FAILURE });
    }
  } catch (e) {
    console.error(e);
    yield put({ type: GET_COUPONS_FAILURE });
  }
}

function* addCoupon(action) {
  const { code } = action;

  const options = {
    method: 'POST',
    uri: `${process.env.REACT_APP_BASE_URL}/customer/add-coupon`,
    form: {
      code
    },
    json: true
  };

  try {
    const data = yield rp(options);

    if (data.success) {
      yield put({
        type: ADD_COUPON_SUCCESS
      });
    } else {
      let failMessage = window.t('error_code.add-coupon-fail');
      if (data.code === '2011') {
        failMessage = window.t('error_code.add-coupon-fail-already-exist');
        helpers.message.error(failMessage, 'account');
      } else {
        helpers.message.error(failMessage, 'account');
      }

      window.dataLayer.push({
        event: 'Promo Code Error',
        promoData: {
          code,
          failMessage
        }
      });

      yield put({ type: ADD_COUPON_FAILURE });
    }
  } catch (e) {
    helpers.message.error(window.t('error_code.add-coupon-fail'), 'account');
    console.error(e);
    yield put({ type: ADD_COUPON_FAILURE });
  }
}

function* saga() {
  yield takeLatest(GET_PAYMENT_METHODS_REQUEST, getPaymentMethods);
  yield takeLatest(GET_PAYMENT_METHOD_REQUEST, getPaymentMethod);
  yield takeLatest(ADD_PAYMENT_METHOD_REQUEST, addPaymentMethod);
  yield takeLatest(GET_ADDRESSES_REQUEST, getAddresses);
  yield takeEvery(UPDATE_ADDRESS_TYPE_REQUEST, updateAddressType);
  yield takeLatest(GET_TRANSACTIONS_REQUEST, getTransactions);
  yield takeLatest(GET_RESCHEDULE_PICKUP_REQUEST, getReschedulePickup);
  yield takeLatest(ADD_RESCHEDULE_PICKUP_REQUEST, addReschedulePickup);
  yield takeLatest(GET_INFO_REQUEST, getInfo);
  yield takeLatest(GET_COUPONS_REQUEST, getCoupons);
  yield takeLatest(ADD_COUPON_REQUEST, addCoupon);
  yield takeLatest(ADD_ADDRESS_REQUEST, addAddress);
}

const reducer = (state = {}, action) => {
  switch (action.type) {
    case GET_PAYMENT_METHODS_REQUEST:
      return {
        ...state,
        loading: true,
        getPaymentMethodsSuccess: false
      };
    case GET_PAYMENT_METHODS_SUCCESS:
      return {
        ...state,
        loading: false,
        paymentMethods: action.paymentMethods,
        getPaymentMethodsSuccess: true
      };
    case GET_PAYMENT_METHODS_FAILURE:
      return {
        ...state,
        loading: false,
        getPaymentMethodsSuccess: false
      };
    case GET_PAYMENT_METHOD_REQUEST:
      return {
        ...state,
        loading: true,
        paymentMethodDetail: false
      };
    case GET_PAYMENT_METHOD_SUCCESS:
      return {
        ...state,
        loading: false,
        paymentMethodDetail: action.paymentMethodDetail
      };
    case GET_PAYMENT_METHOD_FAILURE:
      return {
        ...state,
        loading: false,
        paymentMethodDetail: false
      };
    case ADD_PAYMENT_METHOD_REQUEST:
      return {
        ...state,
        loading: true,
        addPaymentMethodSuccess: false,
        addPaymentMethodFail: false
      };
    case ADD_PAYMENT_METHOD_SUCCESS:
      return {
        ...state,
        loading: false,
        addPaymentMethodSuccess: true,
        addPaymentMethodFail: false
      };
    case ADD_PAYMENT_METHOD_FAILURE:
      return {
        ...state,
        loading: false,
        addPaymentMethodSuccess: false,
        addPaymentMethodFail: true
      };
    case ADD_ADDRESS_REQUEST:
      return {
        ...state
      };
    case ADD_ADDRESS_SUCCESS:
      return {
        ...state,
        addresses: [].concat(action.addresses, state.addresses)
      };
    case ADD_ADDRESS_FAILURE:
      return {
        ...state
      };
    case UPDATE_ADDRESS_TYPE_REQUEST:
      return {
        ...state,
        updateAddressSuccess: false
      };
    case UPDATE_ADDRESS_TYPE_SUCCESS:
      return {
        ...state,
        updateAddressSuccess: true
      };
    case UPDATE_ADDRESS_TYPE_FAILURE:
      return {
        ...state,
        updateAddressSuccess: false
      };
    case GET_ADDRESSES_REQUEST:
      return {
        ...state,
        loading: true,
        addresses: false
      };
    case GET_ADDRESSES_SUCCESS:
      return {
        ...state,
        loading: false,
        addresses: action.addresses
      };
    case GET_ADDRESSES_FAILURE:
      return {
        ...state,
        loading: false,
        addresses: false
      };
    case GET_TRANSACTIONS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case GET_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        transactions: action.transactions
      };
    case GET_TRANSACTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        transactions: false
      };
    case GET_RESCHEDULE_PICKUP_REQUEST: {
      const obj = {
        ...state,
        loading: true
      };
      delete obj.addReschedulePickupSuccess;
      delete obj.canReschedule;
      return obj;
    }
    case GET_RESCHEDULE_PICKUP_SUCCESS:
      return {
        ...state,
        loading: false,
        canReschedule: action.canReschedule,
        timeDate: action.timeDate
      };
    case GET_RESCHEDULE_PICKUP_FAILURE:
      return {
        ...state,
        loading: false,
        error: true
      };
    case ADD_RESCHEDULE_PICKUP_REQUEST:
      return {
        ...state,
        loading: true
      };
    case ADD_RESCHEDULE_PICKUP_SUCCESS:
      return {
        ...state,
        loading: false,
        addReschedulePickupSuccess: true
      };
    case ADD_RESCHEDULE_PICKUP_FAILURE:
      return {
        ...state,
        loading: false,
        addReschedulePickupSuccess: false,
        message: action.message
      };
    case GET_INFO_REQUEST:
      return {
        ...state,
        info: false,
        getInfoSuccess: false
      };
    case GET_INFO_SUCCESS:
      return {
        ...state,
        info: action.info,
        getInfoSuccess: true
      };
    case GET_INFO_FAILURE:
      return {
        ...state,
        info: false,
        getInfoSuccess: false
      };
    case GET_COUPONS_REQUEST:
      return {
        ...state,
        loading: true
        // coupons: false
      };
    case GET_COUPONS_SUCCESS:
      return {
        ...state,
        loading: false,
        coupons: action.coupons
      };
    case GET_COUPONS_FAILURE:
      return {
        ...state,
        loading: false,
        coupons: false
      };
    case ADD_COUPON_REQUEST:
      return {
        ...state,
        loading: true,
        addCouponSuccess: false
      };
    case ADD_COUPON_SUCCESS:
      return {
        ...state,
        loading: false,
        addCouponSuccess: true
      };
    case ADD_COUPON_FAILURE:
      return {
        ...state,
        loading: false,
        addCouponSuccess: false
      };
    default:
      return state;
  }
};

export default {
  saga,
  reducer
};
